import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

export default function PlanCreditDates({ wallet }) {
  return (
    <Row className="mb-5 small text-gray-700 fw-light">
      <Col lg={6} xl={5} xxl={4}>
        Your Plan expires on:
        {' '}
        {wallet ? wallet.attributes.plan_expires_on : '...'}
      </Col>

      <Col lg={6} xl={5} xxl={4} className="mt-1 mt-lg-0">
        Next credit expires on:
        {' '}
        {wallet ? wallet.attributes.next_credit_expires_on : '...'}
      </Col>
    </Row>
  );
}

PlanCreditDates.propTypes = {
  wallet: PropTypes.object,
};

PlanCreditDates.defaultProps = {
  wallet: null,
};
